/* image.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./image.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
const CSS_VAR_MAX_WIDTH = '--max-width';
const CSS_VAR_MAX_HEIGHT = '--max-height';
const imageStyles = null;

/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */
const Image = ({
  maxHeight,
  maxWidth,
  height = 'auto',
  width = 'auto',
  src
}) => /*#__PURE__*/React.createElement("img", {
  style: {
    [CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
    [CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
  },
  width: width,
  height: height,
  alt: "",
  role: "presentation",
  src: src,
  className: ax(["_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"])
});
export default Image;